import React from "react"

class TimePickerDepricated extends React.Component {
    
    constructor(props) {
      super(props);
      this.onChange = this.onChange.bind(this);
    };

    componentDidMount() {
      let $timePicker = $(this.refs.timepicker);
      $timePicker.timepicker();
      $timePicker.timepicker('setTime', this.props.value);
      $timePicker.on('changeTime.timepicker', this.onChange);
      $timePicker.on('keydown', function (e) {
        if (e.keyCode == 9) {
          $(this).timepicker('hideWidget');
        }
      });
    };

    componentWillUnmount() {
      $(this.refs.timepicker).remove()
    }
    
    render() {
      return(
        <div id={this.props.name} className={`input-group bootstrap-timepicker ${this.props.className || ""}`}>

          <input type="time" ></input>
          <input ref="timepicker" type="text" className={`form-control input-small ${this.props.className || ""}`} data-show-meridian={this.props.meridian} data-custom-meridian={this.props.customMeridian}/>
          {/* <span className={`input-group-addon ${this.props.className || ""}`}><i className="ss-clock"></i></span> */}
        </div>
      );
    };

    onChange(event) {
      // console.log('onChange timepicker', event.time);
      
      if (event.target.className.includes('filter') || event.target.className.includes('campaign-time-field')) {
        this.props.onChange(event.time.value, this.props.name);
      } else {
        this.props.onChange(event.time.value)
      }
    };

};

// export default TimePicker